import React from "react";

import { prettyPrintJson } from 'pretty-print-json';
import 'pretty-print-json/css/pretty-print-json.prefers.min.css'

import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import {Accordion, AccordionSummary, Stack} from "@mui/joy";
import AccordionDetails from "@mui/joy/AccordionDetails";
import Chip from "@mui/joy/Chip";

// components
import VariableRepresentation from "./VariableRepresentation";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import BaseApi from "../../utils/BaseApi";

// icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


class AgentRunStepCard extends React.Component {

    async process(){
        const url = `agent_run_step/${this.props.agentRunStep.id}/process/`;
        const api = new BaseApi();
        await api.get(url, {});
    }

    async reprocess(){
        const url = `agent_run_step/${this.props.agentRunStep.id}/reprocess/`;
        const api = new BaseApi();
        await api.get(url, {});
    }

    render() {
        return(
            <Card>
                <CardContent>
                    <Stack
                        direction={'row'}
                        spacing={1}
                        useFlexGap
                        sx={{
                            flexWrap: 'wrap',
                            alignItems: 'center',
                        }}
                    >
                        <Typography
                            level="title-md"
                        >
                            {this.props.agentRunStep.node.title}
                        </Typography>
                        <Chip
                            color={this.props.agentRunStep.node.node_class_meta.color}
                        >
                            {this.props.agentRunStep.node.xtype_human}
                        </Chip>
                        {
                            this.props.agentRunStep.completed?
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                    useFlexGap
                                    sx={{
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                    }}
                                >
                                    <CheckCircleIcon
                                        color={'success'}
                                        sx={{display: 'flex'}}
                                    />
                                    <CommonCallBackButton
                                        icon={null}
                                        label={'Перезапустить'}
                                        color={'primary'}
                                        variant={'plain'}
                                        callBack={this.reprocess.bind(this)}
                                    />
                                </Stack>:
                                <CommonCallBackButton
                                    icon={null}
                                    label={'Продолжить'}
                                    color={'primary'}
                                    variant={'plain'}
                                    callBack={this.process.bind(this)}
                                />
                        }

                    </Stack>
                    <Stack
                        direction={'row'}
                        spacing={1}
                    >
                        <Typography
                            level="body-md"
                        >
                            Создано {this.props.agentRunStep.created_on}
                        </Typography>
                        <Typography
                            level="body-md"
                        >
                            Обновлено {this.props.agentRunStep.updated_on}
                        </Typography>
                    </Stack>
                    <Stack
                        direction={'row'}
                        spacing={1}
                    >
                        <Typography
                            level="body-md"
                        >
                            Начало действия {this.props.agentRunStep.action_start}
                        </Typography>
                        <Typography
                            level="body-md"
                        >
                            Конец действия {this.props.agentRunStep.action_end}
                        </Typography>
                    </Stack>
                    <Stack
                        direction={'row'}
                        spacing={1}
                    >
                        <Typography
                            level="body-md"
                        >
                            Задача celery {this.props.agentRunStep.celery_task_id}
                        </Typography>
                    </Stack>
                    <Typography
                        level="title-md"
                    >
                        Обработанные переменные
                    </Typography>
                    <Card
                        sx={{
                            height: '300px',
                            overflow: 'scroll'
                        }}
                    >
                        <Stack
                            spacing={1}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                }}
                            >
                                {
                                    Object.keys(this.props.agentRunStep.processed_variables).map(k => (
                                        <VariableRepresentation
                                            name={k}
                                            value={this.props.agentRunStep.processed_variables[k]}
                                            type={this.props.agentRunStep.node.node_class_meta.request_variables_types[k]}
                                        />
                                    ))
                                }
                            </Stack>
                            <Accordion>
                                <AccordionSummary>Сырой вид</AccordionSummary>
                                <AccordionDetails>
                                    <pre
                                        style={{
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word'
                                        }}
                                        className={'json-container'}
                                        dangerouslySetInnerHTML={{
                                            __html: prettyPrintJson.toHtml(
                                                this.props.agentRunStep.processed_variables,
                                                {
                                                    indent: 4,
                                                    quoteKeys: "",
                                                }
                                            )
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        </Stack>
                    </Card>
                    <Typography
                        level="title-md"
                    >
                        Результат
                    </Typography>
                    <Card
                        sx={{
                            height: '300px',
                            overflow: 'scroll'
                        }}
                    >
                        <Stack
                            spacing={1}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                useFlexGap
                                sx={{
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                }}
                            >
                                {
                                    Object.keys(this.props.agentRunStep.result).map(k => (
                                        <VariableRepresentation
                                            name={k}
                                            value={this.props.agentRunStep.result[k]}
                                            type={this.props.agentRunStep.node.node_class_meta.response_variables_types[k]}
                                        />
                                    ))
                                }
                            </Stack>
                            <Accordion>
                                <AccordionSummary>Сырой вид</AccordionSummary>
                                <AccordionDetails>
                                    <pre
                                        style={{
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word'
                                        }}
                                        className={'json-container'}
                                        dangerouslySetInnerHTML={{
                                            __html: prettyPrintJson.toHtml(
                                                this.props.agentRunStep.result,
                                                {
                                                    indent: 4,
                                                    quoteKeys: "",
                                                }
                                            )
                                        }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        </Stack>
                    </Card>
                </CardContent>
            </Card>

        )
    }
}

export default AgentRunStepCard;
